import { BaseModel } from '../mongo/base.model';
import { DomainModel } from './domain.model';
import { UserModel } from './user.model';

export class CustomerRequirementsModel extends BaseModel {
  _id: string;
  opportunity_rfid: string;
  is_gcp: boolean;
  created_by_rfid: string;
  domain_rfid: string;
  customer_requirement_status: string;
  draft: boolean;
  approval_phases: any[];
  google_doc_id: string;
  proposal_time: string;
  created_at;
  start_date: Date;
  deleted: boolean;
  //CUSTOM
  user: any;
  domain: DomainModel;
  creation_date_string: string;
  managerApprovalPart: any;
  gpmApprovalPart: any;
  sendingToCustomerPart: any;
  googleDocUrl: any;
  consumed_time: string;
  created_by_email: string;

  constructor() {
    super();
  }

  getSortedApprovalPhasesByDateDesc(): any[] {
    return this.approval_phases
      ? this.approval_phases.sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        })
      : [];
  }

  canApprove(user: UserModel): boolean {
    return (
      this.managerApprovalPart &&
      user._id == this.managerApprovalPart.id &&
      (!this.managerApprovalPart.date || !this.managerApprovalPart.approved)
    );
  }
  canSendToCustomer(user: UserModel): boolean {
    return (
      user.isEngineer &&
      (!this.user.manager_user_id || this.managerApprovalPart?.date) &&
      this.sendingToCustomerPart &&
      this.sendingToCustomerPart.date == null
    );
  }
}
